// extracted by mini-css-extract-plugin
export default {"item":"VirtualListItem_item__c8bmu"};